import { areSameOpticianDetails } from './optician-details.js';
import { areSamePrescriptionParameters } from './prescription-parameters.js';

const isSamePrescription = (server, draft)=>{
    if (server.isEmailPrescription) {
        return draft.type === 'email-prescription';
    } else if (server.isExistingCustomer) {
        return draft.type === 'existing-customer';
    } else if (server.prescriptionFile && server.pupillaryDistanceFile) {
        if (draft.type !== 'prescription-file') {
            return false;
        }
        return draft.details.prescriptionFile.storageId === server.prescriptionFile.storageId && draft.details.pupillaryDistanceFile.storageId === server.pupillaryDistanceFile.storageId;
    }
    if (draft.type !== 'new-prescription' || !server.newPrescription) {
        return false;
    }
    const { leftLens , rightLens , expiryDate , opticianDetails  } = server.newPrescription;
    return areSamePrescriptionParameters(leftLens, draft.details.leftLens) && areSamePrescriptionParameters(rightLens, draft.details.rightLens) && areSameOpticianDetails({
        expiryDate,
        opticianDetails
    }, draft.details);
};

export { isSamePrescription };
//# sourceMappingURL=prescription.js.map
